module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-plus-1f1f43f15157e243474bc53daa675132.svg";